import { connect } from 'react-redux'

const storeConnect = ({ mapStateToProps, mapDispatchToProps, mergeProps, options }) => (
  connect(mapStateToProps, mapDispatchToProps, mergeProps, options)
)

export default storeConnect
